// extracted by mini-css-extract-plugin
export default {"text":"PlaygroundToolCallMessage-module__text--lvAdt"};